function initArticleTOC({
  contentSelectorsId,
  excludedComponents,
  printSelectors,
}) {
  const currentSize = window
      .getComputedStyle(document.querySelector('.social-share-buttons'))
      .getPropertyValue('content')
      .replace(/'|"/g, '');
  if (currentSize == 'desktop') {
    document.getElementById('article-index-main').open = true;
  }

  // Collect all h2-h5 inside article content
  const containers = contentSelectorsId
    .map(id => document.getElementById(id))
    .filter(el => el !== null);

  let allHeadlines = containers
    .flatMap(container => [...container.querySelectorAll('h2, h3, h4, h5')])
    .filter(headline => {
      if (!headline.textContent.trim()) return false;
      for (const ex of excludedComponents) {
        if (headline.closest(`.${ex}`)) return false;
      }
      return true;
    });

  // Add IDs to headings if missing
  allHeadlines.forEach(h => {
    if (!h.id) {
      h.id = h.textContent
        .trim()
        .toLowerCase()
        .replaceAll('ä', 'ae')
        .replaceAll('ö', 'oe')
        .replaceAll('ü', 'ue')
        .replaceAll('ß', 'ss')
        .replace(/[^\w\s]|_/g, '')
        .replace(/\s+/g, '-');
    }
      h.classList.add('article-headline');
  });

  // Function to build TOC recursively
  function buildTOC(headlines, startIndex = 0, level = 2) {
    let html = '';
    for (let i = startIndex; i < headlines.length; i++) {
      let h = headlines[i];
      let hLevel = parseInt(h.tagName.substring(1));
      if (hLevel < level) return { html, endIndex: i - 1 };
      if (hLevel > level) {
        // Nest deeper
        const nested = buildTOC(headlines, i, hLevel);
        html += nested.html;
        i = nested.endIndex;
        continue;
      }

      // Check if next headings are deeper to decide if we need nested <ul>
      let hasSub = false;
      if (i + 1 < headlines.length) {
        const nextLevel = parseInt(headlines[i + 1].tagName.substring(1));
        if (nextLevel > hLevel) hasSub = true;
      }

      html += `<li${hasSub ? ' class="has-sub"' : ''}>`;
      if (hasSub) {
        html += `<button class="btn arrow" aria-label="Toggle section" aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="currentColor">
                      <path d="M8.90435 6.63518C8.7241 6.81542 8.7241 7.10765 8.90435 7.2879L14.1165 12.5L8.90435 17.7121C8.7241 17.8923 8.7241 18.1846 8.90435 18.3648C9.08459 18.5451 9.37682 18.5451 9.55706 18.3648L15.0955 12.8264C15.2758 12.6461 15.2758 12.3539 15.0955 12.1736L9.55706 6.63518C9.37682 6.45494 9.08459 6.45494 8.90435 6.63518Z"/>
                    </svg>
                  </button>`;
      }
      const firstChild = h.firstElementChild;
      const linkContent = (firstChild && firstChild.tagName === 'A') ? firstChild.innerHTML : h.innerHTML;
      html += `<a href="#${h.id}">${linkContent}</a>`;

      if (hasSub) {
        const nested = buildTOC(headlines, i + 1, hLevel + 1);
        html += `<ul class="nested">` + nested.html + `</ul>`;
        i = nested.endIndex;
      }

      html += `</li>`;
    }
    return { html, endIndex: headlines.length - 1 };
  }

  // Generate TOC HTML
  const tocHTML = buildTOC(allHeadlines).html;
  const sidebar = document.getElementById('article-index-main');
  const inlinebar = document.querySelector('.article-index-inline');

  if (tocHTML.trim() === '') {
    // hide all if nothing for TOC
    if (sidebar) sidebar.classList.remove('d-md-block');
    if (inlinebar) inlinebar.hidden = true;
  } else {
    // show TOC
    if (sidebar) {
      sidebar.hidden = false;
      document.getElementById('article-index').innerHTML = `<ul class="toc" role="navigation" aria-label="Inhaltsverzeichnis">` + tocHTML + `</ul>`;
    }
    if (inlinebar && document.getElementById('article-index-inline')) {
      document.getElementById('article-index-inline').innerHTML = `<ul class="toc" role="navigation" aria-label="Inhaltsverzeichnis">` + tocHTML + `</ul>`;
      inlinebar.classList.remove('d-none');
    }
  }

  // Collapsible functionality for nested lists with arrow buttons
  document.querySelectorAll('.toc li.has-sub').forEach(li => {
    const arrow = li.querySelector('.arrow');
    const nestedUl = li.querySelector('ul.nested');

    if (nestedUl) {
      nestedUl.classList.add('d-none') // hide by default

      arrow.addEventListener('click', e => {
        e.preventDefault();
        const isOpen = nestedUl.classList.contains('d-block');
        nestedUl.classList.toggle('d-block', !isOpen);
        nestedUl.classList.toggle('d-none', isOpen);

        li.classList.toggle('open', !isOpen);
        arrow.setAttribute('aria-expanded', !isOpen);

      });
    }
  });

  // Hide elements if more than 4
  const VISIBLE_ITEMS = 4;

  function initInlineTocExpand() {
    const btn = document.getElementById('article-index-inline-expand-btn');
    const toc = document.getElementById('article-index-inline');
    if (!btn || !toc) return;

    const items = toc.querySelectorAll('ul.toc > li');

    // Hide items beyond 4
    const hiddenItems = [...items].slice(VISIBLE_ITEMS);

    // Show button only if there are more than 4 items
    if (hiddenItems.length === 0) {
      btn.hidden = true;
      return;
    }
    btn.hidden = false;

    hiddenItems.forEach(el => el.hidden = true);

    btn.addEventListener('click', () => {
      hiddenItems.forEach(el => el.hidden = false);
      btn.hidden = true; // hide button after expanding
      hiddenItems[0].querySelector('button, a')?.focus();
    });
  }

  initInlineTocExpand();

  // Highlight current headline on scroll
  function inView(element) {
    const scrollY = window.scrollY || window.pageYOffset; // get number of pixels that the document is scrolled
    const scrollPosition = scrollY + window.innerHeight / 3; // get current scroll position (distance from the top of the page to the bottom of the current viewport)
    const elementPosition = element.getBoundingClientRect().top + scrollY; // get element position (distance from the top of the page to the bottom of the element)
    return scrollPosition > elementPosition; // returns true if scrollPosition > elementPosition, false if not
  }

  window.addEventListener('scroll', () => {
    let current = null;
    for (let i = 0; i < allHeadlines.length; i++) {
      const link = document.querySelector('#article-sidebar a[href="#' + allHeadlines[i].id + '"]');
      if (link) link.classList.remove('active');
      if (inView(allHeadlines[i])) current = i;
    }
    if (current !== null) {
      const activeLink = document.querySelector('#article-sidebar a[href="#' + allHeadlines[current].id + '"]');
      if (activeLink) activeLink.classList.add('active');
    }
  });

  // Adjust scroll for anchor links
  window.addEventListener('hashchange', () => {
      window.scrollTo(window.scrollX, window.scrollY - window.innerHeight / 6);
  });

  // Mobile: collapse TOC on link click
  if (currentSize === 'mobile') {
    document.querySelectorAll('.sidebar-index a').forEach(item => {
      item.addEventListener('click', () => {
        document.getElementById('article-index-main').removeAttribute('open');
      });
    });
  };

  // Open accordions for print
  if (printSelectors !== null) {
    window.addEventListener('beforeprint', () => {
      document.querySelectorAll(printSelectors).forEach(el => {
        el.setAttribute('open', 'open');
      });
    });

    window.addEventListener('afterprint', () => {
      document.querySelectorAll(printSelectors).forEach(el => {
        el.removeAttribute('open');
      });
    });
  }
}

window.initArticleTOC = initArticleTOC;
